module.exports = __webpack_public_path__ + "static/media/faccia_09.8b0605d4.png";